import { render, staticRenderFns } from "./MyNumber.vue?vue&type=template&id=3e754cd4&scoped=true&"
import script from "./MyNumber.vue?vue&type=script&lang=js&"
export * from "./MyNumber.vue?vue&type=script&lang=js&"
import style0 from "./MyNumber.vue?vue&type=style&index=0&id=3e754cd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e754cd4",
  null
  
)

export default component.exports